module.exports = __webpack_public_path__ + "img/chevron-back-outline.5d06d707.svg";